import { render, staticRenderFns } from "./DuplicateIpnConflictsDetail.vue?vue&type=template&id=7d06f1b9&scoped=true&"
import script from "./DuplicateIpnConflictsDetail.vue?vue&type=script&lang=js&"
export * from "./DuplicateIpnConflictsDetail.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateIpnConflictsDetail.vue?vue&type=style&index=0&id=7d06f1b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d06f1b9",
  null
  
)

export default component.exports